"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const form_1 = require("./form");
const captcha_1 = require("./captcha/captcha");
const env_1 = require("../env");
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default('forms:index');
function detectForms() {
    return Array
        .from(document.getElementsByTagName('form'))
        .filter(form => form.hasAttribute(constants_1.FORM_NAME_KEY));
}
function documentReady() {
    if (!document) {
        debug('no document, returning');
        return;
    }
    debug('waiting for document to be ready');
    return new Promise(resolve => {
        // in case the document is already rendered
        if (document.readyState !== 'loading') {
            resolve();
        }
        else if (document.addEventListener) { // modern browsers
            document.addEventListener('DOMContentLoaded', () => resolve());
        }
        else { // IE <= 8
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState === 'complete') {
                    resolve();
                }
            });
        }
    });
}
function init(forms) {
    return __awaiter(this, void 0, void 0, function* () {
        debug('initializing forms', forms);
        yield env_1.initEnv();
        yield captcha_1.initCaptcha();
        let formsToBind = forms;
        if (!forms) {
            yield documentReady();
            formsToBind = detectForms();
        }
        debug('binding forms', formsToBind);
        return formsToBind.map(form => new form_1.Form(form));
    });
}
exports.default = {
    Form: form_1.Form,
    init,
};
